import { render, staticRenderFns } from "./ActivityQuestions.vue?vue&type=template&id=0587976b&"
import script from "./ActivityQuestions.vue?vue&type=script&lang=js&"
export * from "./ActivityQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports